import  { useState, useContext, useEffect } from "react";
import { Button, Modal, Table, Form, Spinner, OverlayTrigger, Tooltip } from "react-bootstrap";

import NotyfContext from "../contexts/NotyfContext";

import { UserSettingsContext } from "../contexts/UserSettingsContext";

import { ExternalLink} from "react-feather";
import authenticatedFetch from "../utils/fetch"

import TaskAssigneeSelect from "./TaskAssigneeSelect";
import rawTaskStatuses from "./taskStatuses";
import rawPsvTypes from "./psvTypes";
import ActivityRow from "./ActivityRow";
import UsStateSelect from "./UsStateSelect";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInfoCircle
} from "@fortawesome/free-solid-svg-icons";

import NextActionDatePicker from "./NextActionDatePicker";
import rawPsvResults from "./psvResults";


// allowedPracticeIds optionally restricts the options to those practices
const PracticeSelect = ({taskId, selectedPracticeId, disabled, handlePracticeChanged, allowedPracticeIds}) => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [data, setData] = useState([]);
  
    useEffect(() => {
      authenticatedFetch({
        path: "practice/revenueteam",
        additionalHeaders: {"taskId": taskId},
        successHandler: function(result) {
          setIsLoaded(true);
          setData(result);
        },
        errorHandler: function(error) {
          setIsLoaded(true);
          setError(error);
        }
      });
    }, [taskId])
  
    if (!isLoaded)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Loading...</option></Form.Select>);
    }
    else if (error || !data)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Error... Please reload the page...</option></Form.Select>);
    }
    else
    {
      let practiceOptionList = [<option value={0} key={0}>Select a practice...</option>];
      const visible = allowedPracticeIds ? data.filter((practice) => allowedPracticeIds.map(Number).includes(practice.id)) : data;
      practiceOptionList.push(visible.map((practice, i) => {
        return (
          <option value={practice.id} key={practice.id}>{practice.name}</option>
        )
      }, this));
  
      return (
        <Form.Select disabled={disabled} onChange={(e) => {handlePracticeChanged(e.target.value, e)}} value={selectedPracticeId}>{practiceOptionList}</Form.Select>
      )
    }
  }
  
  const CarrierSelect = ({ taskId, practiceId, disabled, selectedCarrierId, handleCarrierChanged}) => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [data, setData] = useState([]);
  
    useEffect(() => {
      if (practiceId > 0)
      {
        authenticatedFetch({
          path: "carrier/practice/" + practiceId,
          additionalHeaders: {"taskId": taskId},
          successHandler: function(result) {
            setIsLoaded(true);
            setData(result);
          },
          errorHandler: function(error) {
            setIsLoaded(true);
            setError(error);
          }
        });
      }
      else
      {
        setData([]);
      }
    }, [practiceId, taskId])
  
    if (practiceId == null || practiceId <= 0)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Please first select a practice...</option></Form.Select>);
    }
    else if (!isLoaded)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Loading...</option></Form.Select>);
    }
    else if (error || !data)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Error... Please reload the page...</option></Form.Select>);
    }
    else
    {
      let carrierOptionList = [<option value={0} key={0}>Select a carrier...</option>];
      carrierOptionList.push(data.map((carrier, i) => {
        return (
          <option value={carrier.id} key={carrier.id}>{carrier.name}</option>
        )
      }, this));
  
      return (
        <Form.Select disabled={disabled} onChange={(e) => {handleCarrierChanged(e.target.value, e)}} value={selectedCarrierId}>{carrierOptionList}</Form.Select>
      )
    }
  }
  
  // allowedProviderId optionally restricts the options to that one provider
  const ProviderSelect = ({ taskId, practiceId, disabled, selectedProviderId, handleProviderChanged, allowedProviderId}) => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
      if (practiceId > 0)
      {
        authenticatedFetch({
          path: "provider/practice/" + practiceId,
          additionalHeaders: {"taskId": taskId},
          successHandler: function(result) {
            setIsLoaded(true);
            setData(result);
          },
          errorHandler: function(error) {
            setIsLoaded(true);
            setError(error);
          }
        });
      }
      else
      {
        setData([]);
      }
    }, [practiceId, taskId])

    // Preselect the allowed provider once the practice's providers load, if it is among them
    useEffect(() => {
      if (allowedProviderId && !(selectedProviderId > 0) && data.some((provider) => provider.id === Number(allowedProviderId)))
      {
        handleProviderChanged(allowedProviderId, null);
      }
    }, [data])
  
    if (practiceId == null || practiceId <= 0)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Please first select a practice...</option></Form.Select>);
    }
    else if (!isLoaded)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Loading...</option></Form.Select>);
    }
    else if (error || !data)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Error... Please reload the page...</option></Form.Select>);
    }
    else
    {
      let providerOptionList = [<option value={0} key={0}>Select a provider...</option>];
      const visible = allowedProviderId ? data.filter((provider) => provider.id === Number(allowedProviderId)) : data;
      providerOptionList.push(visible.map((provider, i) => {
        return (
          <option value={provider.id} key={provider.id}>{provider.lastName}, {provider.firstName} {provider.middleName}</option>
        )
      }, this));
  
      return (
        <Form.Select disabled={disabled} onChange={(e) => {handleProviderChanged(e.target.value, e)}} value={selectedProviderId}>{providerOptionList}</Form.Select>
      )
    }
  }
  
const HubSelect = ({ taskId, providerId, practiceId, disabled, selectedHubId, handleHubChanged}) => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [data, setData] = useState([]);
  
    useEffect(() => {
      if (providerId > 0)
      {
        authenticatedFetch({
          path: "hub/provider/" + providerId,
          additionalHeaders: {"taskId": taskId},
          successHandler: function(result) {
            setIsLoaded(true);
            setData(result);
          },
          errorHandler: function(error) {
            setIsLoaded(true);
            setError(error);
          }
        });
      }
      else if (practiceId > 0)
      {
        authenticatedFetch({
          path: "hub/practice/" + practiceId,
          additionalHeaders: {"taskId": taskId},
          successHandler: function(result) {
            setIsLoaded(true);
            setData(result);
          },
          errorHandler: function(error) {
            setIsLoaded(true);
            setError(error);
          }
        });
      }
      else
      {
        setData([]);
      }
    }, [providerId, practiceId, taskId])
  
    if ((providerId == null || providerId <= 0) && (practiceId == null || practiceId <= 0))
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Please first select a provider or practice...</option></Form.Select>);
    }
    else if (!isLoaded)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Loading...</option></Form.Select>);
    }
    else if (error || !data)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Error... Please reload the page...</option></Form.Select>);
    }
    else
    {
      let hubOptionList = [<option value={0} key={0}>Select a data hub ({providerId != null && providerId > 0 ? "provider" : "practice"})...</option>];
      hubOptionList.push(data.map((hub, i) => {
        return (
          <option value={hub.id} key={hub.id}>{hub.name}</option>
        )
      }, this));
  
      return (
        <Form.Select disabled={disabled} onChange={(e) => {handleHubChanged(e.target.value, e)}} value={selectedHubId}>{hubOptionList}</Form.Select>
      )
    }
}

const FacilitySelect = ({ taskId, practiceId, disabled, selectedFacilityId, handleFacilityChanged}) => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [data, setData] = useState([]);
  
    useEffect(() => {
      if (practiceId > 0)
      {
        authenticatedFetch({
          path: "facility/practice/" + practiceId,
          additionalHeaders: {"taskId": taskId},
          successHandler: function(result) {
            setIsLoaded(true);
            setData(result);
          },
          errorHandler: function(error) {
            setIsLoaded(true);
            setError(error);
          }
        });
      }
      else
      {
        setData([]);
      }
    }, [practiceId, taskId])
  
    if (practiceId == null || practiceId <= 0)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Please first select a practice...</option></Form.Select>);
    }
    else if (!isLoaded)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Loading...</option></Form.Select>);
    }
    else if (error || !data)
    {
      return (<Form.Select disabled={true}><option value={0} key={0}>Error... Please reload the page...</option></Form.Select>);
    }
    else
    {
      let facilityOptionList = [<option value={0} key={0}>Select a location...</option>];
      facilityOptionList.push(data.map((facility, i) => {
        return (
          <option value={facility.id} key={facility.id}>{facility.name}</option>
        )
      }, this));
  
      return (
        <Form.Select disabled={disabled} onChange={(e) => {handleFacilityChanged(e.target.value, e)}} value={selectedFacilityId}>{facilityOptionList}</Form.Select>
      )
    }
}

const NewAttestationDateModal = ({ show, onHide, onComplete, newAttestationDate, handleNewAttestationDateChanged, handleSkip}) => {
  const handleComplete = () => {
    if (newAttestationDate === null || newAttestationDate === "")
    {
      alert("Please specify next attestation date");
      return;
    }

    onComplete();
  }

  const setToDaysFromToday = (days) => {
    const newDate = new Date();

    const target = new Date(
      newDate.getFullYear(),
      newDate.getMonth(),
      newDate.getDate() + days
    );
    
    const year = target.getFullYear();
    const month = String(target.getMonth() + 1).padStart(2, "0");
    const day = String(target.getDate()).padStart(2, "0");

    // Local date string, no UTC conversion
    handleNewAttestationDateChanged(`${year}-${month}-${day}`);
  }

  const currentDaysFromToday = () => {
    if (newAttestationDate === null || newAttestationDate === "")
    {
      return null;
    }

    const today = new Date();

    let parts = newAttestationDate.split("-");
    const attestationDate = new Date(parts[0], parts[1] - 1, parts[2]);  // Avoid the UTC->local timezone translation issue with js

    const diffTime = attestationDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
  }

  useEffect(() => {
    if (show && !newAttestationDate)
    {
      setToDaysFromToday(120);
    }
  }, [show])

  return (
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
          <Modal.Title>
            <span style={{fontSize: "0.9em", fontWeight: "normal"}}>Specify Next Attestation Date</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table> 
            <tbody>
              <tr>
                  <td>Next Attestation Date:</td>
                  <td style={{whiteSpace: 'nowrap'}}>
                    <Button size="sm" disabled={currentDaysFromToday() === 90} onClick={() => {setToDaysFromToday(90)}}>90 Days</Button>&nbsp;
                    <Button size="sm" disabled={currentDaysFromToday() === 120} onClick={() => {setToDaysFromToday(120)}}>120 Days</Button>&nbsp;
                    <Button size="sm" disabled={currentDaysFromToday() === 180} onClick={() => {setToDaysFromToday(180)}}>180 Days</Button>
                  </td>
                  <td><Form.Control onChange={(e) => {handleNewAttestationDateChanged(e.target.value)}} type="date" value={newAttestationDate} placeholder="New attestation date" /></td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
            <Button className="me-auto btn-secondary" onClick={handleSkip} size="sm">Skip</Button>
            <Button onClick={handleComplete}>Complete Task</Button>
        </Modal.Footer>
      </Modal>
  );
}

const NewExpirationDateDateModal = ({ show, onHide, onComplete, forceNewExpirationRefresh, newExpirationDate, handleNewExpirationDateChanged, noExpirationDate, handleNoExpirationDateChanged, isInitial, newEffectiveDate, handleNewEffectiveDateChanged, newPayorNumber, handleNewPayorNumberChanged, showSendEmailNotification, sendEmailNotification, handleSendEmailNotificationChanged, handleSkip, handleNewParticipationFilesChanged, isCarrier}) => {
  const { isH3Admin, authorities } = useContext(UserSettingsContext);
  const canEditDocuments = isH3Admin || authorities.includes("PROVIDER_DOCUMENT_EDIT");
  
  const onEffectiveDateChanged = (value, e) => {
    handleNewEffectiveDateChanged(value, e);

    if ((!newExpirationDate || newExpirationDate === "") && !noExpirationDate)
    {
      var parts = value.split("-");
  
      // If they just started keying in the date, it will come over as, e.g. 0002, and we don't want to interpret that as a real date and then set it as the value; just set this raw string value, e.g. 0002-12-21
      if (parseInt(parts[0]) > 1970)
      {
        var aYearFromNow = new Date(value);
        aYearFromNow.setFullYear(aYearFromNow.getFullYear() + 3);
        aYearFromNow.setDate(aYearFromNow.getDate() - 1);
        handleNewExpirationDateChanged(aYearFromNow.toISOString().split('T')[0], e);
      }
    }
  }

  const handleComplete = () => {
    if (isInitial && (newEffectiveDate === null || newEffectiveDate === ""))
    {
      alert("Please specify effective date");
      return;
    }

    if (!noExpirationDate && (newExpirationDate === null || newExpirationDate === ""))
    {
      alert("Please specify expiration date");
      return; 
    }


    if (isInitial && isCarrier)
    {
      alert("Don't forget to activate LOBs for this provider + carrier, if applicable!")
    }

    onComplete();
  }

  return (
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
          <Modal.Title>
            <span style={{fontSize: "0.9em", fontWeight: "normal"}}>{isInitial ? "Specify Effective & Expiration Dates" : "Specify Next Expiration Date"}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table> 
            <tbody>
              {isInitial &&
              <tr>
                  <td>Effective Date:</td>
                  <td><Form.Control onChange={(e) => {onEffectiveDateChanged(e.target.value, e)}} type="date" value={newEffectiveDate} placeholder="Next effective date" /></td>
              </tr>
              }
              <tr>
                  <td>{isInitial ? "" : "Next"} <span>Expiration Date:</span>{isInitial ? <><br /><span style={{fontSize: "0.9em"}}>(No End Date&nbsp;<Form.Check checked={noExpirationDate} onChange={(e) => {handleNoExpirationDateChanged(e.target.checked)}} style={{display: "inline"}}/>)</span></> : <></>}</td>
                  <td><Form.Control key={forceNewExpirationRefresh} disabled={noExpirationDate} onChange={(e) => {handleNewExpirationDateChanged(e.target.value, e)}} type="date" value={newExpirationDate} placeholder="Next expiration date" /></td>
              </tr>
              {(isInitial && isCarrier) ?
              <tr>
                  <td>Payor Number:</td>
                  <td><Form.Control onChange={(e) => {handleNewPayorNumberChanged(e.target.value, e)}} type="text" value={newPayorNumber}/></td>
              </tr>
              : <></>
              }
              {canEditDocuments &&
              <tr>
                  <td>Enrollment Document(s):</td>
                  <td><Form.Control type="file" multiple onChange={(e) => {handleNewParticipationFilesChanged(e.target.files)}} /></td>
              </tr>
              }
              {showSendEmailNotification &&
              <tr>
                  <td>Send Email Notification:</td>
                  <td><Form.Check checked={sendEmailNotification} onChange={(e) => {handleSendEmailNotificationChanged(e.target.checked)}} /></td>
              </tr>
              }
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
            <Button className="me-auto btn-secondary" onClick={handleSkip} size="sm">Skip</Button>
            <Button onClick={handleComplete}>Complete Task</Button>
        </Modal.Footer>
      </Modal>
  );
}

const PsvResultModal = ({ show, onHide, onComplete, newPsvResult, handleNewPsvResultChanged, handleNewPsvFilesChanged, handleSkip}) => {

  const { isH3Admin, authorities } = useContext(UserSettingsContext);
  const canEditDocuments = isH3Admin || authorities.includes("PROVIDER_DOCUMENT_EDIT");

  if (newPsvResult == null)
  {
    newPsvResult = "";
  }

  const handleComplete = () => {
    if (newPsvResult === null || newPsvResult === "")
    {
      alert("Please specify PSV result");
      return;
    }

    onComplete();
  }

  const newPsvResultList = rawPsvResults.map((newPsvResult, i) => {
    return (
      <option key={i} value={newPsvResult.value}>{newPsvResult.label}</option>
    )
  }, this);

  return (
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
          <Modal.Title>
            <span style={{fontSize: "0.9em", fontWeight: "normal"}}>Specify Primary Source Verification Result</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table> 
            <tbody>
              <tr>
                  <td>PSV Result:</td>
                  <td>
                    <Form.Select value={newPsvResult} onChange={(e) => {handleNewPsvResultChanged(e.target.value)}} style={{width: "auto"}} >
                        {newPsvResultList}
                    </Form.Select>
                  </td>
              </tr>
              {canEditDocuments &&
              <tr>
                  <td>Document(s):</td>
                  <td><Form.Control type="file" multiple onChange={(e) => {handleNewPsvFilesChanged(e.target.files)}} /></td>
              </tr>
              }
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
            <Button className="me-auto btn-secondary" onClick={handleSkip} size="sm">Skip</Button>
            <Button onClick={handleComplete}>Complete Task</Button>
        </Modal.Footer>
      </Modal>
  );
}

const DocumentModal = ({ show, onHide, onComplete, newDocumentFiles, handleNewDocumentFilesChanged, newDocumentExpirationDate, handleNewDocumentExpirationDateChanged, newDocumentEffectiveDate, handleNewDocumentEffectiveDateChanged, onSkip}) => {

  const handleComplete = () => {
    onComplete();
  }

  const handleSkip = () => {
    if (!window.confirm("Provider/Admin hasn't uploaded the required document(s) yet. Are you sure you want to skip this step and complete the task? We'll still create downstream tasks and a new shell data record."))
    {
      return;
    }

    onSkip();
  }

  return (
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
          <div>
            <Modal.Title>
              <span style={{fontSize: "0.9em", fontWeight: "normal"}}>Upload Document(s)</span>
            </Modal.Title>
            <p className="mb-0 mt-1" style={{fontSize: "0.85em"}}>Please upload required document(s), and specify document details to complete this task.</p>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Table> 
            <tbody>
              <tr>
                  <td>Effective Date:</td>
                  <td><Form.Control onChange={(e) => {handleNewDocumentEffectiveDateChanged(e.target.value, e)}} type="date" value={newDocumentEffectiveDate} placeholder="Next effective date" /></td>
              </tr>
              <tr>
                  <td>Expiration Date:</td>
                  <td><Form.Control onChange={(e) => {handleNewDocumentExpirationDateChanged(e.target.value, e)}} type="date" value={newDocumentExpirationDate} placeholder="Next expiration date" /></td>
              </tr>
              <tr>
                  <td>Document(s):</td>
                  <td><Form.Control type="file" multiple onChange={(e) => {handleNewDocumentFilesChanged(e.target.files)}} /></td>
              </tr>
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
            <Button className="me-auto btn-secondary" onClick={handleSkip} size="sm">Skip</Button>
            <Button disabled={newDocumentFiles == null || newDocumentFiles.length === 0 || newDocumentEffectiveDate == null || newDocumentEffectiveDate.length === 0 || newDocumentExpirationDate == null || newDocumentExpirationDate.length === 0} onClick={handleComplete}>Complete Task</Button>
        </Modal.Footer>
      </Modal>
  );
}


const BoldSignESignatureModal = ({ taskId, show, onHide, onComplete}) => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState({});
  const [templateName, setTemplateName] = useState("Loading...");
  
  const BOLDSIGN_ORIGIN = "https://app.boldsign.com";

  const handleHide = () => {
    if (window.confirm("Are you sure you want to hide the e-signature modal? Unsaved progress will be lost.")) {
      onHide();
    }
  }

  useEffect(() => {
    if (!show) return;

    setIsLoaded(false);
    setError(null);
    setData({});
    setTemplateName("Loading...");

    authenticatedFetch({
      path: "task/" + taskId + "/esignatureforms",
      additionalHeaders: {"taskId": taskId},
      successHandler: function(result) {
        setIsLoaded(true);
        setData(result);
        if (result && result.url != null && result.templateName && result.urlIndex >= 0) 
        {
          setTemplateName(result.templateName);
        }
        else if (result.url === null && result.hasMore)
        {
          getNextDocument(result.urlIndex);  // Skip if already signed
        }
        else
        {
          completeSigning();
        }
      },
      errorHandler: function(error) {
        setIsLoaded(true);
        setError(error);
      }
    });
  }, [taskId, show])

  useEffect(() => {
    if (!show) return;
    if (!isLoaded || error) return;
    if (!data || data.url == null || data.urlIndex < 0) return;

    function handleMessage(event) {
      if (event.origin !== BOLDSIGN_ORIGIN) return;

      switch (event.data.action) 
      {
        case "onDocumentSigned":
          if (data.hasMore) {
            getNextDocument(data.urlIndex);
          } else {
            completeSigning();
          }
          break;
        case "onDocumentSigningFailed":
          alert("Signing failed, please try again.");
          break;
        default:
          break;
      }
    }

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);  // cleanup on next render
  }, [show, data, isLoaded, error]);

  async function completeSigning() {
    onComplete();
  }

  async function getNextDocument(currentUrlIndex) {
    setIsLoaded(false);
    setError(null);
    setData({});
    setTemplateName("Loading...");

    authenticatedFetch({
      path: "task/" + taskId + "/esignatureforms",
      additionalHeaders: {"taskId": taskId, 'requestedUrlIndex': currentUrlIndex + 1},
      successHandler: function(result) {
        setIsLoaded(true);
        setData(result);
        if (result && result.url != null && result.urlIndex > 0 && result.templateName) 
        {
          setTemplateName(result.templateName);
        }
        else if (result.url === null && result.hasMore)
        {
          getNextDocument(result.urlIndex);  // Skip if already signed
        }
        else
        {
          completeSigning();
        }
      },
      errorHandler: function(error) {
        setIsLoaded(true);
        setError(error);
      }
    });
  }

  let body = <></>;
  if (!isLoaded)
  {
    body = 
      <>
        <p className="lead">Loading...</p>
        <br />
        <Spinner animation="border" size="sm" />
        <br /><br />
      </>
  }
  else if (error || !data)
  {
    body = 
      <>
        <p className="lead">Error... Please reload the page...</p>
        <br /><br />
      </>
  }

  let title = "Review E-Signature Forms | " + templateName; 

  return (
      <Modal show={show} onHide={handleHide} centered dialogClassName={"modal-1200"}>
        <Modal.Header closeButton style={{backgroundColor: '#DEF2F1', paddingTop: "0.5rem", paddingBottom: "0.5rem"}}>
          <Modal.Title>
            <span style={{fontSize: "0.9em", fontWeight: "normal"}}>{title}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{height: "700px"}}>
          {body}
          {data.url &&
            <iframe src={data.url} key={data.urlIndex} title="Document Signing" style={{height: "100%", width: "100%", border: "none"}} />
          }
        </Modal.Body>
        <Modal.Footer style={{backgroundColor: '#DEF2F1', paddingTop: "0.5rem", paddingBottom: "0.5rem"}}>
            <Button onClick={handleHide}>Close</Button>
        </Modal.Footer>
      </Modal>
  );
}

const ESignaturePacketDownload = ({taskId}) => {
  const notyf = useContext(NotyfContext);

  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadClicked = (e) => {
    e.preventDefault();
    setIsDownloading(true);

    authenticatedFetch({
      method: "POST",
      path:  "task/" + taskId + "/esignatureforms/files/signeddownloadurl",
      additionalHeaders: {"taskId": taskId},
      successHandler: function(result) {
        setIsDownloading(false);

        for (var i=0; i<result.urls.length; i++)
        {
          window.open(result.urls[i]);
        }
      },
      errorHandler: function(error) {
        setIsDownloading(false);
        notyf.open({type: "error", message: "Something went wrong; please try again", duration: 5000, dismissable: true, ripple: true});
      }
    });
  }

  return (
    isDownloading ?
    <Spinner animation="border" size="sm" />
    :
    <Button size="sm" onClick={(e) => {handleDownloadClicked(e)}}>Download packet</Button>
  )
}

const TaskModal = ({ id, category, practiceId, psvType, state, carrierId, providerId, hubId, facilityId, other, referenceNumber, assignees, status, due, deadline, archived, activityList, eSignatureTokenInfo, documentTokenInfo, tracked, show, onCancel, onSave, onRefresh, onDelete, allowedPracticeIds, allowedProviderId }) => {
    const [localId] = useState(id);
    const [localStatus, setLocalStatus] = useState(status);
    const [localCategory, setLocalCategory] = useState(category);
    const [localPsvType, setLocalPsvType] = useState(psvType);
    const [localState, setLocalState] = useState(state);
    const [localPracticeId, setLocalPracticeId] = useState(practiceId);
    const [localCarrierId, setLocalCarrierId] = useState(carrierId);
    const [localProviderId, setLocalProviderId] = useState(providerId);
    const [localHubId, setLocalHubId] = useState(hubId);
    const [localFacilityId, setLocalFacilityId] = useState(facilityId);
    const [localOther, setLocalOther] = useState(other);
    const [localReferenceNumber, setLocalReferenceNumber] = useState(referenceNumber);
    const [localDue, setLocalDue] = useState(due);
    const [localDeadline, setLocalDeadline] = useState(deadline);
    const [localArchived, setLocalArchived] = useState(archived);
    const [localTracked, setLocalTracked] = useState(tracked);
    const [isSaving, setIsSaving] = useState(false);
  
    const [newActivity, setNewActivity] = useState('');
    const [localActivityDeletes, setLocalActivityDeletes] = useState([]);

    const [showNewAttestationDateModal, setShowNewAttestationDateModal] = useState(false);
    const [newAttestationDate, setNewAttestationDate] = useState('');

    const [showNewExpirationDateModal, setShowNewExpirationDateModal] = useState(false);
    const [newExpirationDate, setNewExpirationDate] = useState('');
    const [noExpirationDate, setNoExpirationDate] = useState(false);
    const [forceNewExpirationRefresh, setForceNewExpirationRefresh] = useState(0);
    const [newEffectiveDate, setNewEffectiveDate] = useState('');
    const [newPayorNumber, setNewPayorNumber] = useState('');
    const [newParticipationFiles, setNewParticipationFiles] = useState([]);
    const [sendEmailNotification, setSendEmailNotification] = useState(false);

    const [showPsvResultModal, setShowPsvResultModal] = useState(false);
    const [newPsvResult, setNewPsvResult] = useState('');
    const [newPsvFiles, setNewPsvFiles] = useState([]);

    const [showDocumentModal, setShowDocumentModal] = useState(false);
    const [newDocumentFiles, setNewDocumentFiles] = useState([]);
    const [newDocumentExpirationDate, setNewDocumentExpirationDate] = useState('');
    const [newDocumentEffectiveDate, setNewDocumentEffectiveDate] = useState('');

    const [localSendProviderNotification, setLocalSendProviderNotification] = useState(false);
    const [localSendApprover1Notification, setLocalSendApprover1Notification] = useState(false);
    const [localSendApprover2Notification, setLocalSendApprover2Notification] = useState(false);
    const [showBoldSignESignatureModal, setShowBoldSignESignatureModal] = useState(false);
    const [packetStatusUpdating, setPacketStatusUpdating] = useState(false);

    const [taskSettings, setTaskSettings] = useState(null);
  
    const { isH3Admin, authorities } = useContext(UserSettingsContext);
    const canEdit = isH3Admin || authorities.includes("TASK_EDIT");
  
    const notyf = useContext(NotyfContext);

    useEffect(() => {
      if (!show || !isH3Admin) return;

      authenticatedFetch({
        path: "task/settings",
        additionalHeaders: {"taskId": id},
        successHandler: function(result) {
          setTaskSettings(result)
        }
      });
    }, [show, isH3Admin, id]);
      
    // On create, may not touch these
    if (localStatus == null) {
      setLocalStatus("CREATED")
    }
  
    if (localCategory == null) {
      setLocalCategory("INITIAL_ENROLLMENT");
    }

    if (localPsvType == null) {
      setLocalPsvType("");
    }

    if (localState == null) {
      setLocalState("");
    }
  
    if (localOther == null) {
      setLocalOther("");
    }

    if (localReferenceNumber == null) {
      setLocalReferenceNumber("");
    }

    // This will always be touched, but react doesn't like us starting it off as null
    if (localDue == null) {
      let twoBizDays = new Date();
      twoBizDays.setDate(twoBizDays.getDate() + 2);

      if (twoBizDays.getDay() === 6 || twoBizDays.getDay() === 0)
      {
          twoBizDays.setDate(twoBizDays.getDate() + 2);
      }

      setLocalDue(twoBizDays.getFullYear() + "-" + String(twoBizDays.getMonth() + 1).padStart(2, '0') + "-" + String(twoBizDays.getDate()).padStart(2, '0'));
    }

    if (localDeadline == null) {
      setLocalDeadline("");
    }
  
    // Have to format the local assignees here to structure the plugin can understand
    let formattedAssignees = null;  // Null to allow task select to auto-select first assignee
    if (assignees != null && assignees.length > 0)
    {
      formattedAssignees = [];
      for (var i=0; i<assignees.length; i++)
      {
        formattedAssignees.push({value: assignees[i].userId, label:assignees[i].firstName + ' ' + assignees[i].lastName});
      }
    }
    const [localAssignees, setLocalAssignees] = useState(formattedAssignees);
  
    const handleAssigneesChanged = (assignees) => {
      setLocalAssignees(assignees);
    }
  
    const handleStatusChanged = (status, e) => {
      if (e != null) {
        e.preventDefault();
      }
  
      setLocalStatus(status);
    }
  
    const handleCategoryChanged = (category, e) => {
      if (e != null) {
        e.preventDefault();
      }
  
      setLocalCategory(category);

      if (category !== "PSV")
      {
        setLocalPsvType("");
        setLocalState("");
      }
    }

    const handlePsvTypeChanged = (psvType, e) => {
      if (e != null) {
        e.preventDefault();
      }

      setLocalPsvType(psvType);
    }

    function handleStateChanged(name, newValue) {
      setLocalState(newValue);
    }
  
    const handlePracticeChanged = (practiceId, e) => {
      if (e != null) {
        e.preventDefault();
      }
  
      setLocalPracticeId(practiceId);
  
      // Clear the other values that are dependent on practice
      setLocalCarrierId(0);
      setLocalProviderId(0);
      setLocalHubId(0);
      setLocalFacilityId(0);
    }
  
    const handleCarrierChanged = (carrierId, e) => {
      if (e != null) {
        e.preventDefault();
      }
  
      setLocalCarrierId(carrierId);
    }
  
    const handleProviderChanged = (providerId, e) => {
      if (e != null) {
        e.preventDefault();
      }
  
      setLocalProviderId(providerId);
      setLocalHubId(0);
    }
  
    const handleHubChanged = (hubId, e) => {
      if (e != null) {
        e.preventDefault();
      }
  
      setLocalHubId(hubId);
    }
  
    const handleFacilityChanged = (facilityId, e) => {
        if (e != null) {
          e.preventDefault();
        }
    
        setLocalFacilityId(facilityId);
      }

    const handleOtherChanged = (other, e) => {
      if (e != null) {
        e.preventDefault();
      }
  
      setLocalOther(other);
    }

    const handleReferenceNumberChanged = (referenceNumber, e) => {
      if (e != null) {
        e.preventDefault();
      }
  
      setLocalReferenceNumber(referenceNumber);
    }
  
    const handleDueChanged = (due) => {
      setLocalDue(due);
    }

    const handleDeadlineChanged = (deadline, e) => {
      if (e != null) {
        e.preventDefault();
      }
  
      setLocalDeadline(deadline);
    }

    const handleArchivedChanged = (archived) => {
      setLocalArchived(archived);
    }

    const handleTrackedChanged = (tracked) => {
      setLocalTracked(tracked);
    }
    
    const handleNewActivityChanged = (newActivity, e) => {
      if (e != null) {
        e.preventDefault();
      }
  
      setNewActivity(newActivity);
    }

    const handleActivityDelete = (e, activityId) => {
      e.preventDefault();

      if (!window.confirm("Are you sure you want to delete this note?"))
      {
        return;
      }

      setLocalActivityDeletes([...localActivityDeletes, activityId]);
    }

    const handleNoExpirationDateChanged = (val) => {
      setNoExpirationDate(val);
      
      if (val)
      {
        setNewExpirationDate('');
        // If the date entered is incomplete (e.g. 02/07/yyyy), the internal value stays blank, so setting it here doesn't trigger a re-render; use a force refresh to make sure we blank it out
        setForceNewExpirationRefresh(forceNewExpirationRefresh + 1);
      }
    }

    const handleSendProviderNotificationChanged = (e) => {
      setLocalSendProviderNotification(e.target.checked);
    }

    const handleSendApprover1NotificationChanged = (e) => {
      setLocalSendApprover1Notification(e.target.checked);
    }

    const handleSendApprover2NotificationChanged = (e) => {
      setLocalSendApprover2Notification(e.target.checked);
    }
    
  
    const reset = () => {
      setLocalStatus(status);
      setLocalCategory(category);
      setLocalPsvType(psvType);
      setLocalState(state);
      setLocalPracticeId(practiceId);
      setLocalCarrierId(carrierId);
      setLocalProviderId(providerId);
      setLocalHubId(hubId);
      setLocalFacilityId(facilityId);
      setLocalOther(other);
      setLocalReferenceNumber(referenceNumber);
      setLocalDue(due);
      setLocalDeadline(deadline);
      setLocalArchived(archived);
      setLocalTracked(tracked);
      setLocalAssignees(formattedAssignees);
      setNewActivity('');
      setLocalActivityDeletes([]);
      setIsSaving(false);
      setNewAttestationDate('');
      setNewExpirationDate('');
      setNoExpirationDate(false);
      setNewEffectiveDate('');
      setNewPsvResult('');
      setNewPsvFiles([]);
      setNewDocumentFiles([]);
      setNewDocumentExpirationDate('');
      setNewDocumentEffectiveDate('');
      setNewPayorNumber('');
      setNewParticipationFiles([]);
      setSendEmailNotification(false);
      setLocalSendProviderNotification(false);
      setLocalSendApprover1Notification(false);
      setLocalSendApprover2Notification(false);
    }
  
    const handleCancel = () => {
      reset();
      onCancel();
    }
  
    const handleDelete = () => {
        if (window.confirm("Are you sure you want to delete this task?"))
        {
          authenticatedFetch({
            path: "task/" + id,
            additionalHeaders: {"taskId": id},
            method: "DELETE",
            successHandler: function(result) {
              onDelete();
  
              notyf.open({type: "error", message: "Deleted!", duration: 5000, dismissable: true, ripple: true, background: '#3AAFA9'});
            },
            errorHandler: function(error) {
              alert("Something went wrong; please try again");
            }
          });
        }
    }

    const doSubmit = (expirationOrAttestationModalSkipped=false) => {
      const requestData = {
        id: localId,
        status: localStatus,
        category: localCategory,
        psvType: localPsvType,
        state: localState,
        practiceId: localPracticeId,
        carrierId: localCarrierId,
        providerId: localProviderId,
        hubId: localHubId,
        facilityId: localFacilityId,
        other: localOther,
        referenceNumber: localReferenceNumber,
        due: localDue,
        deadline: localDeadline,
        archived: localArchived,
        tracked: localTracked,
        newActivity: newActivity,
        activityDeletes: localActivityDeletes,
        assignees: localAssignees,
        newAttestationDate: expirationOrAttestationModalSkipped ? null : newAttestationDate,
        newExpirationDate: expirationOrAttestationModalSkipped ? null : newExpirationDate,
        newEffectiveDate: expirationOrAttestationModalSkipped ? null : newEffectiveDate,
        newPayorNumber: expirationOrAttestationModalSkipped ? null : newPayorNumber,
        newPsvResult: expirationOrAttestationModalSkipped ? null : newPsvResult,
        newPsvFiles: expirationOrAttestationModalSkipped ? [] : newPsvFiles,
        newDocumentFiles: expirationOrAttestationModalSkipped ? [] : newDocumentFiles,
        newDocumentExpirationDate: expirationOrAttestationModalSkipped ? null : newDocumentExpirationDate,
        newDocumentEffectiveDate: expirationOrAttestationModalSkipped ? null : newDocumentEffectiveDate,
        newParticipationFiles: expirationOrAttestationModalSkipped ? [] : newParticipationFiles,
        sendEmailNotification: expirationOrAttestationModalSkipped ? false : sendEmailNotification,
        sendProviderNotification: localSendProviderNotification,
        sendApprover1Notification: localSendApprover1Notification,
        sendApprover2Notification: localSendApprover2Notification
      };
    
      var formData = new FormData();
      formData.append("data", new Blob([JSON.stringify(requestData)], {
          type: "application/json"
      }));

      const psvFiles = Array.from(expirationOrAttestationModalSkipped ? [] : (newPsvFiles || []));
      psvFiles.forEach((file) => {
        formData.append("newPsvFiles", file);
      });

      const documentFiles = Array.from(expirationOrAttestationModalSkipped ? [] : (newDocumentFiles || []));
      documentFiles.forEach((file) => {
        formData.append("newDocumentFiles", file);
      });

      const participationFiles = Array.from(expirationOrAttestationModalSkipped ? [] : (newParticipationFiles || []));
      participationFiles.forEach((file) => {
        formData.append("newParticipationFiles", file);
      });

      authenticatedFetch({
        path: "task",
        method: "POST",
        requestData: formData,
        formData: true,
        additionalHeaders: {"taskId": localId ? localId : null},
        successHandler: function(result) {
          setNewActivity('');
          setIsSaving(false);
  
          var message = "Updated!";
          if (localId == null || localId === 0)
          {
            message = "Created!";
            reset(); // If this is the shared "new" task modal, need to reset everything
          }

          if (result.warningMessage)
          {
            message += " " + result.warningMessage;
          }
  
          onSave();
  
          if (result.warningMessage)
          {
            notyf.open({type: "warning", message: message, duration: 5000, dismissable: true, ripple: true});
          }
          else
          {
            notyf.open({type: "success", message: message, duration: 5000, dismissable: true, ripple: true, background: '#3AAFA9'});
          }
        },
        errorHandler: function() {
          alert("Something went wrong; please try again");
          setNewActivity('');
          setIsSaving(false);
        }
      });
    }

    const onHideNewAttestationDateModal = () => {
      setShowNewAttestationDateModal(false);
      setIsSaving(false);
    }

    const onCompleteNewAttestationDateModal = () => {
      setShowNewAttestationDateModal(false);
      doSubmit();
    }

    const onSkipNewAttestationDateModal = () => {
      setShowNewAttestationDateModal(false);
      doSubmit(true);
    }

    const onCompleteNewExpirationDateModal = () => {
      setShowNewExpirationDateModal(false);
      doSubmit();
    }

    const onSkipNewExpirationDateModal = () => {
      setShowNewExpirationDateModal(false);
      doSubmit(true);
    }

    const onHideNewExpirationDateModal = () => {
      setShowNewExpirationDateModal(false);
      setIsSaving(false);
    }

    const onHidePsvResultModal = () => {
      setNewPsvFiles([]);
      setShowPsvResultModal(false);
      setIsSaving(false);
    }

    const onCompletePsvResultModal = () => {
      setShowPsvResultModal(false);
      doSubmit();
    }

    const onSkipPsvResultModal = () => {
      setShowPsvResultModal(false);
      doSubmit(true);
    }

    const handleNewPsvFilesChanged = (files) => {
      setNewPsvFiles(files || []);
    }

    const onHideDocumentModal = () => {
      setNewDocumentFiles([]);
      setNewDocumentExpirationDate('');
      setNewDocumentEffectiveDate('');
      setShowDocumentModal(false);
      setIsSaving(false);
    }

    const onCompleteDocumentModal = () => {
      setShowDocumentModal(false);
      doSubmit();
    }

    const onSkipDocumentModal = () => {
      setShowDocumentModal(false);
      doSubmit(true);
    }

    const handleNewDocumentFilesChanged = (files) => {
      setNewDocumentFiles(files || []);
    }

    const handleNewDocumentExpirationDateChanged = (val, e) => {
      setNewDocumentExpirationDate(val);
    }

    const handleNewDocumentEffectiveDateChanged = (val, e) => {
      setNewDocumentEffectiveDate(val);
    }

    const handleNewParticipationFilesChanged = (files) => {
      setNewParticipationFiles(files || []);
    }

    const handleReviewFormsClicked = () => {
      setShowBoldSignESignatureModal(true);
    }

    const onCompleteReviewForms = () => {
      setShowBoldSignESignatureModal(false);
      setIsSaving(true);
      setPacketStatusUpdating(true);

      authenticatedFetch({
        path: "task/" + id + "/esignatureforms",
        method: "POST",
        additionalHeaders: {"taskId": id},
        successHandler: function(result) {
          setIsSaving(false);
          setPacketStatusUpdating(false);

          onRefresh();
        },
        errorHandler: function() {
          alert("Something went wrong; please try again");
          setIsSaving(false);
          setPacketStatusUpdating(false);
        }
      });
    }
  
    const handleSave = () => {
      if (localPracticeId === null || localPracticeId === 0)
      {
        alert("Please select a practice");
        return;
      }

      setIsSaving(true);
  
      if (localStatus === "COMPLETE" && status !== "COMPLETE")
      {
        if (localCategory === "ATTESTATION" && localHubId && localHubId !== 0 && localHubId !== '0')
        {
          setShowNewAttestationDateModal(true);
          return;
        }
        else if ((localCategory === "INITIAL_ENROLLMENT" || localCategory === "ANNUAL_ENROLLMENT") && ((localCarrierId && localCarrierId !== 0 && localCarrierId !== '0') || (localFacilityId && localFacilityId !== 0 && localFacilityId !== '0')))
        {
          if (localCategory === "INITIAL_ENROLLMENT")
          {
            // Default to true
            setSendEmailNotification(true);
          }
          else
          {
            setSendEmailNotification(false);
          
          }

          setShowNewExpirationDateModal(true);
          return;
        }
        else if (localCategory === "PSV")
        {
          setShowPsvResultModal(true);
          return;
        }
        else if (hasAssociatedDocumentUpload && documentTokenInfo && (documentTokenInfo.status === "ACTIVE" || documentTokenInfo.status === "UPLOAD_LINK_NOT_SENT"))
        {
          const canEditDocuments = isH3Admin || authorities.includes("PROVIDER_DOCUMENT_EDIT");

          if (canEditDocuments)
          {
            // Make sure status isn't stale
            authenticatedFetch({
              path: "task/" + id + "/documentstatus",
              additionalHeaders: {"taskId": id},
              successHandler: function(result) {
                if (result && (result.status === "ACTIVE" || result.status === "UPLOAD_LINK_NOT_SENT"))
                {
                  setShowDocumentModal(true);
                }
                else
                {
                  doSubmit();
                }
              },
              errorHandler: function() {
                alert("Something went wrong; please try again.");
                setIsSaving(false);
              }
            });

            return;
          }
        }
      }

      doSubmit();
    }
  
    let activityRows = [];
    if (activityList) {
      // Filter out any activities that have been deleted
      const filteredActivityList = activityList.filter((activity) => {
        return !localActivityDeletes.includes(activity.id);
      });
      activityRows.push(filteredActivityList.map((activity, i) => {
        return (
          <ActivityRow key={activity.id} id={activity.id} user={activity.userFormattedName} notes={activity.notes} created={activity.created} canDelete={activity.canDelete} handleDeleteClicked={handleActivityDelete} />
        )
      }, this));
    }
  
    let statusOptionList = rawTaskStatuses.filter((status) => { return status.value !== "" }).map((status, i) => {
        return (
          <option value={status.value} key={status.value}>{status.label}</option>
        )
      }, this);

    let psvTypeOptionList = rawPsvTypes.map((psvType, i) => {
      // Remove the blank option
      if (psvType.value === "") {
        return null;
      }

      return (
        <option key={i} value={psvType.value}>{psvType.label}</option>
      )
    }, this);
  
    let hasAssociatedEsignature = (eSignatureTokenInfo != null);
    let eSignatureStatus = "(unknown)";
    if (hasAssociatedEsignature)
    {
      if (packetStatusUpdating)
      {
        eSignatureStatus = <><Spinner animation="border" size="sm" />&nbsp;&nbsp;Updating...</>;
      }
      else if (eSignatureTokenInfo.status === "ACTIVE_PRE_APPROVER_FORMS")
      {
        eSignatureStatus = <span style={{color: '#3AAFA9'}}><Button onClick={(e) => handleReviewFormsClicked(e)}  size="sm">Review Forms</Button>&nbsp;&nbsp;(Forms generated; pending review)</span>;
      }
      else if (eSignatureTokenInfo.status === "PRE_APPROVER_FORMS_COMPLETE")
      {
        eSignatureStatus = <><span style={{color: '#3AAFA9'}}>(internal e-signature forms review complete)</span><br /><Form.Check disabled={!canEdit} type="switch" checked={localSendProviderNotification} style={{display: "inline"}}  onChange={(e) => {handleSendProviderNotificationChanged(e)}}/>&nbsp;&nbsp;Send link to provider: <span style={{fontFamily: "monospace"}}>{eSignatureTokenInfo.providerName} &lt;{eSignatureTokenInfo.providerEmail}&gt;</span></>;
      }
      else if (eSignatureTokenInfo.status === "ACTIVE_PROVIDER_FORMS")
      {
        eSignatureStatus = <><a href={eSignatureTokenInfo.activeProviderUrl} target="_blank"><ExternalLink style={{'height': '16px', 'width': '16px'}}/>&nbsp;Active provider e-signature forms</a></>
      }
      else if (eSignatureTokenInfo.status === "PROVIDER_FORMS_COMPLETE")
      {
        eSignatureStatus = <><span style={{color: '#3AAFA9'}}>(provider e-signature forms complete)</span><br /><Form.Check disabled={!canEdit} type="switch" checked={localSendApprover1Notification} style={{display: "inline"}}  onChange={(e) => {handleSendApprover1NotificationChanged(e)}}/>&nbsp;&nbsp;Send link to first approver: <span style={{fontFamily: "monospace"}}>{eSignatureTokenInfo.approver1Name} &lt;{eSignatureTokenInfo.approver1Email}&gt;</span></>;
      }
      else if (eSignatureTokenInfo.status === "ACTIVE_APPROVER1_FORMS")
      {
          eSignatureStatus = <><a href={eSignatureTokenInfo.activeApprover1Url} target="_blank"><ExternalLink style={{'height': '16px', 'width': '16px'}}/>&nbsp;Active first approver e-signature forms</a></>
      }
      else if (eSignatureTokenInfo.status === "APPROVER1_FORMS_COMPLETE")
      {
          eSignatureStatus = <><span style={{color: '#3AAFA9'}}>(1st approver e-signature forms complete)</span><br /><Form.Check disabled={!canEdit} type="switch" checked={localSendApprover2Notification} style={{display: "inline"}}  onChange={(e) => {handleSendApprover2NotificationChanged(e)}}/>&nbsp;&nbsp;Send link to final approver: <span style={{fontFamily: "monospace"}}>{eSignatureTokenInfo.approver2Name} &lt;{eSignatureTokenInfo.approver2Email}&gt;</span></>;
      }
      else if (eSignatureTokenInfo.status === "ACTIVE_APPROVER2_FORMS")
      {
            eSignatureStatus = <><a href={eSignatureTokenInfo.activeApprover2Url} target="_blank"><ExternalLink style={{'height': '16px', 'width': '16px'}}/>&nbsp;Active final approver e-signature forms</a></>
      }
      else if (eSignatureTokenInfo.status === "COMPLETE")
      {
        if (eSignatureTokenInfo.missingPacketDependencies.length > 0)
        {
          const missingPacketDependenciesDisplay = eSignatureTokenInfo.missingPacketDependencies.join("; ");
          eSignatureStatus = (
            <OverlayTrigger
            triggers="[hover,focus]"
            placement="bottom"
            overlay={<Tooltip>{missingPacketDependenciesDisplay}</Tooltip>}
            >
              <span className="text-warning"><Button variant="warning" size="sm"><FontAwesomeIcon icon={faInfoCircle}/></Button>&nbsp;&nbsp;(E-signature complete)</span>
          </OverlayTrigger>
          );
        }
        else
        {
          eSignatureStatus = <span style={{color: '#3AAFA9'}}><ESignaturePacketDownload taskId={id}/>&nbsp;&nbsp;(E-signature complete)</span>;
        }
      }
    }

    // TODO packet generation will have other dependencies as well, so ready for packet generation is dependent on those being met also, once the signature proces is done

    let hasAssociatedDocumentUpload = (documentTokenInfo != null);
    let documentUploadStatus = "(unknown)";
    if (hasAssociatedDocumentUpload)
    {
      if (documentTokenInfo.status === "ACTIVE")
      {
        documentUploadStatus = <><a href={documentTokenInfo.activeUrl} target="_blank"><ExternalLink style={{'height': '16px', 'width': '16px'}}/>&nbsp;Active upload link</a></>
      }
      else if (documentTokenInfo.status === "UPLOAD_LINK_NOT_SENT")
      {
        documentUploadStatus = <span style={{color: '#3AAFA9'}}>Upload link not sent</span>;
      }
      else if (documentTokenInfo.status === "COMPLETE")
      {
        documentUploadStatus = <span style={{color: '#3AAFA9'}}>Upload complete</span>;
      }
    }

    return (
      <>
        <Modal show={show} onHide={handleCancel} centered>
          <Modal.Header closeButton style={{backgroundColor: '#DEF2F1'}}>
            <Modal.Title>
              {id > 0 ? "Task Details for (" + id  + ")": "Create New Task"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Table size="sm" striped> 
              <tbody>
                <tr>
                  <td style={{minWidth: "160px"}}>Status</td>
                  <td>
                    <Form.Select disabled={!canEdit} onChange={(e) => {handleStatusChanged(e.target.value, e)}} value={localStatus}>
                      {statusOptionList}
                    </Form.Select>
                  </td>
                </tr>
                <tr>
                  <td>Category</td>
                  <td>
                    <Form.Select disabled={!canEdit || hasAssociatedEsignature || hasAssociatedDocumentUpload} onChange={(e) => {handleCategoryChanged(e.target.value, e)}} value={localCategory}>
                      <option value="INITIAL_ENROLLMENT" key="INITIAL_ENROLLMENT">Initial Enrollment</option>
                      <option value="ANNUAL_ENROLLMENT" key="ANNUAL_ENROLLMENT">Re-enrollment</option>
                      <option value="ATTESTATION" key="ATTESTATION">Attestation</option>
                      <option value="INQUIRY" key="INQUIRY">Inquiry</option>
                      <option value="TERMINATION" key="TERMINATION">Termination</option>
                      <option value="PSV" key="PSV">PSV</option>
                      <option value="OTHER" key="OTHER">Other</option>
                    </Form.Select>
                  </td>
                </tr>
                { localCategory === "PSV" &&
                <>
                <tr>
                  <td>PSV Type</td>
                  <td>
                    <Form.Select disabled={!canEdit || hasAssociatedEsignature || hasAssociatedDocumentUpload} onChange={(e) => {handlePsvTypeChanged(e.target.value, e)}} value={localPsvType}>
                      {psvTypeOptionList}
                    </Form.Select>
                  </td>
                </tr>
                <tr>
                  <td>State</td>
                  <td>
                    <UsStateSelect width="100%"  placeholder="State" originalValue={localState} name="state" onValueChanged={handleStateChanged}/>
                  </td>
                </tr>
                </>
                }
                <tr><td>Practice</td><td><PracticeSelect taskId={id} disabled={!canEdit || hasAssociatedEsignature || hasAssociatedDocumentUpload} selectedPracticeId={localPracticeId} handlePracticeChanged={handlePracticeChanged} allowedPracticeIds={allowedPracticeIds} /></td></tr>
                <tr><td>Carrier</td><td><CarrierSelect taskId={id} disabled={!canEdit  || hasAssociatedEsignature || hasAssociatedDocumentUpload} practiceId={localPracticeId} selectedCarrierId={localCarrierId} handleCarrierChanged={handleCarrierChanged} /></td></tr>
                <tr><td>Provider</td><td><ProviderSelect taskId={id} disabled={!canEdit || hasAssociatedEsignature || hasAssociatedDocumentUpload} practiceId={localPracticeId} selectedProviderId={localProviderId} handleProviderChanged={handleProviderChanged} allowedProviderId={allowedProviderId} /></td></tr>
                <tr><td>Data Hub</td><td><HubSelect taskId={id} disabled={!canEdit || hasAssociatedEsignature || hasAssociatedDocumentUpload} providerId={localProviderId} practiceId={localPracticeId} selectedHubId={localHubId} handleHubChanged={handleHubChanged} /></td></tr>
                <tr><td>Location</td><td><FacilitySelect taskId={id} disabled={!canEdit  || hasAssociatedEsignature || hasAssociatedDocumentUpload} practiceId={localPracticeId} selectedFacilityId={localFacilityId} handleFacilityChanged={handleFacilityChanged} /></td></tr>
                <tr><td>Summary / Headline</td><td><Form.Control disabled={!canEdit} onChange={(e) => {handleOtherChanged(e.target.value, e)}} value={localOther} /></td></tr>
                
                <tr><td>Reference #</td><td><Form.Control disabled={!canEdit} onChange={(e) => {handleReferenceNumberChanged(e.target.value, e)}} value={localReferenceNumber} /></td></tr>
                <tr>
                  <td>Assignees</td>
                  <td><TaskAssigneeSelect taskId={id} disabled={!canEdit} autoSelectFirstAssignee={id == null || id === 0} selectedAssignees={localAssignees} handleAssigneesChanged={handleAssigneesChanged} /></td>
                </tr>
                <tr>
                  <td>Next Action</td>
                  <td>
                    {
                    isH3Admin ? 
                    <NextActionDatePicker taskId={id} disabled={!canEdit} localDue={localDue} handleDueChanged={handleDueChanged} localAssignees={localAssignees}/>
                    :
                    <Form.Control disabled={!canEdit} onChange={(e) => {handleDueChanged(e.target.value)}} type="date" value={localDue} placeholder="Next action date" />
                    }

                    
                  </td>
                </tr>
                <tr>
                  <td>Deadline</td>
                  <td>
                    <Form.Control disabled={!canEdit} onChange={(e) => {handleDeadlineChanged(e.target.value, e)}} type="date" value={localDeadline} placeholder="Deadline" />
                  </td>
                </tr>
                { (((localFacilityId != null && localFacilityId !== 0 && localFacilityId !== '0') || (localCarrierId != null && localCarrierId !== 0 && localCarrierId !== '0')) && (localCategory === "INITIAL_ENROLLMENT" || localCategory === "ANNUAL_ENROLLMENT")) &&
                <tr>
                  <td>Packet Status</td>
                  { hasAssociatedEsignature ?
                  <td>
                    <span>{eSignatureStatus}</span>
                  </td>
                  :
                  <td>n/a</td>
                  }
                </tr>
                }
                {hasAssociatedDocumentUpload &&
                <tr>
                  <td>Document Status</td>
                  <td>
                    <span>{documentUploadStatus}</span>
                  </td>
                </tr>
                }
                {isH3Admin && taskSettings && taskSettings.showTracked &&
                <>
                <tr>
                  <td>Tracked</td>
                  <td><Form.Check disabled={!canEdit} onChange={(e) => {handleTrackedChanged(e.target.checked)}}  checked={!!localTracked} /></td>
                </tr>
                <tr></tr>
                </>
                }
                {status === "COMPLETE" &&
                <>
                <tr>
                  <td>Archived</td>
                  <td><Form.Check disabled={!canEdit} onChange={(e) => {handleArchivedChanged(e.target.checked)}}  checked={!!localArchived} /></td>
                </tr>
                <tr></tr>
                </>
                }
                <tr>
                  <td>Notes</td>
                  <td>
                    <div style={{maxHeight: '200px', overflow: 'auto', display: 'block', width: '100%'}}>
                    <Table striped>
                      <tbody>
                        {canEdit ?
                        <tr><td><Form.Control key={0} onChange={(e) => {handleNewActivityChanged(e.target.value, e)}} value={newActivity} as="textarea" placeholder="Add new note"/></td></tr>
                        : '' }
                        {activityRows}
                      </tbody>
                    </Table>
                    </div>
                  </td>
                </tr>
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer style={{backgroundColor: '#DEF2F1'}}>
            { isSaving ? 
              <Spinner animation="border" size="sm" variant="primary" className="float-end" style={{marginRight: '40px', marginTop: '11px', marginBottom: '11px'}}/>
              :
              <>
                {id != null && id > 0 && isH3Admin ? <Button className="me-auto btn-secondary" onClick={handleDelete}>Delete</Button> : ''}
                <Button onClick={handleCancel}>{canEdit ? 'Cancel' : 'Close'}</Button>
                {canEdit ?
                <Button onClick={handleSave}>{id == null || id <= 0 ? "Create Task" : "Update Task"}</Button>
                : '' }
              </>
            }
          </Modal.Footer>
        </Modal>
      <NewAttestationDateModal show={showNewAttestationDateModal} onComplete={onCompleteNewAttestationDateModal} onHide={onHideNewAttestationDateModal} handleSkip={onSkipNewAttestationDateModal} newAttestationDate={newAttestationDate} handleNewAttestationDateChanged={(newAttestationDate) => setNewAttestationDate(newAttestationDate)} />
      <NewExpirationDateDateModal show={showNewExpirationDateModal} onComplete={onCompleteNewExpirationDateModal} onHide={onHideNewExpirationDateModal} handleSkip={onSkipNewExpirationDateModal} 
        newExpirationDate={newExpirationDate} handleNewExpirationDateChanged={(newExpirationDate) => setNewExpirationDate(newExpirationDate)} 
        noExpirationDate={noExpirationDate} handleNoExpirationDateChanged={handleNoExpirationDateChanged}
        forceNewExpirationRefresh={forceNewExpirationRefresh}
        isInitial={localCategory === "INITIAL_ENROLLMENT"} newEffectiveDate={newEffectiveDate} handleNewEffectiveDateChanged={(newEffectiveDate) => setNewEffectiveDate(newEffectiveDate)}
        newPayorNumber={newPayorNumber} handleNewPayorNumberChanged={(newPayorNumber) => setNewPayorNumber(newPayorNumber)} 
        showSendEmailNotification={!!((localCategory === "INITIAL_ENROLLMENT" || localCategory === "ANNUAL_ENROLLMENT") && (localProviderId && localProviderId !== 0 && localProviderId !== '0') && ((localCarrierId && localCarrierId !== 0 && localCarrierId !== '0') || (localFacilityId && localFacilityId !== 0 && localFacilityId !== '0')))} 
        sendEmailNotification={sendEmailNotification} handleSendEmailNotificationChanged={(sendEmailNotification) => setSendEmailNotification(sendEmailNotification)}
        handleNewParticipationFilesChanged={handleNewParticipationFilesChanged}
        isCarrier={(localCarrierId && localCarrierId !== 0 && localCarrierId !== '0')}/>
      <PsvResultModal newPsvResult={newPsvResult} handleNewPsvResultChanged={(newPsvResult) => setNewPsvResult(newPsvResult)} handleNewPsvFilesChanged={handleNewPsvFilesChanged} show={showPsvResultModal} onHide={onHidePsvResultModal} onComplete={onCompletePsvResultModal} handleSkip={onSkipPsvResultModal} />
      <DocumentModal newDocumentFiles={newDocumentFiles} handleNewDocumentFilesChanged={handleNewDocumentFilesChanged} newDocumentExpirationDate={newDocumentExpirationDate} handleNewDocumentExpirationDateChanged={handleNewDocumentExpirationDateChanged} newDocumentEffectiveDate={newDocumentEffectiveDate} handleNewDocumentEffectiveDateChanged={handleNewDocumentEffectiveDateChanged} taskId={id} show={showDocumentModal} onHide={onHideDocumentModal} onComplete={onCompleteDocumentModal} onSkip={onSkipDocumentModal} />
      <BoldSignESignatureModal taskId={id} show={showBoldSignESignatureModal} onComplete={onCompleteReviewForms} onHide={() => setShowBoldSignESignatureModal(false)} />
      </>
    );
}

  export default TaskModal;